import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components';
import { colorUsage, getSpacing } from 'stylesheet';
export var Container = styled.div.withConfig({
  displayName: "MetaUrlFieldstyle__Container",
  componentId: "sc-13077ev-0"
})(["display:flex;align-items:center;"]);
export var StyledLinearProgress = styled(LinearProgress).withConfig({
  displayName: "MetaUrlFieldstyle__StyledLinearProgress",
  componentId: "sc-13077ev-1"
})(["flex-grow:1;max-width:150px;margin:0 ", ";"], getSpacing(2));
export var Label = styled.div.withConfig({
  displayName: "MetaUrlFieldstyle__Label",
  componentId: "sc-13077ev-2"
})(["margin-right:", ";color:", ";white-space:nowrap;"], getSpacing(1), colorUsage.textColor);
export var Link = styled.a.withConfig({
  displayName: "MetaUrlFieldstyle__Link",
  componentId: "sc-13077ev-3"
})(["color:", ";"], colorUsage.textColorLight);